import { Button } from "@thetreep/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { routes } from "@routes";
import { QuestionAnswerBlock } from "./help/QuestionAnswerBlock";
import { HelpVideo } from "./help/HelpVideo";

export default function FAQ() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openIndices, setOpenIndices] = useState<number[]>([]);

  const allFaqs = t("faq.questions", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  const faqs = allFaqs.slice(0, 2);

  const setIsOpened = (index: number, isOpened: boolean) => {
    if (isOpened) {
      setOpenIndices([...openIndices, index]);
    } else {
      setOpenIndices(openIndices.filter((i) => i !== index));
    }
  };

  return (
    <div className="w-full max-w-[936px] mx-auto px-5 lg:px-0 py-10 md:py-28 flex flex-col gap-8 md:gap-19">
      <h2 className="text-center font-jakarta font-bold text-blue-medium text-[24px] md:text-[40px] ">
        {t("home.faqTitle")}
      </h2>

      <ul>
        {faqs.map((faq, index) => (
          <QuestionAnswerBlock
            key={index}
            index={index}
            question={faq.question}
            answer={faq.answer}
            isOpened={openIndices.includes(index)}
            setIsOpened={setIsOpened}
            className={`${index === 0 ? "" : "border-t"} border-grey-blue-300 py-6 md:py-8 text-text-strong`}
          />
        ))}
      </ul>
      <Button
        kind="outline"
        size="compact"
        alignself="center"
        onClick={() => navigate(routes.HELP)}
      >
        {t("home.allAnswersInFAQ")}
      </Button>
      <HelpVideo />
    </div>
  );
}
